/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module DiagramModules
 */

const moduleName = 'diagram';
const componentName = 'avi-bar-graph';
const prefix = `${moduleName}.${componentName}`;

export const totalLabel = `${prefix}.totalLabel`;
export const errLabel = `${prefix}.errLabel`;

export const ENGLISH = {
    [totalLabel]: 'Total',
    [errLabel]: 'An error occurred while loading the graph, please try again.',
};
